import type { BlogPost } from './types'

export const PHOTOVOLTAIK_FOERDERUNG_2026: BlogPost = {
  slug: 'photovoltaik-foerderung-2026',
  lang: 'de',
  topicId: 'photovoltaik-foerderung-2026',
  title: 'Photovoltaik-Förderung 2026: DE & Österreich',
  metaDescription:
    'Überblick über die wichtigsten Photovoltaik-Förderungen 2026 in Deutschland (MwSt, EEG, ' +
    'KfW-270) und Österreich (EAG). Stand: Juli 2026.',
  keywords: [
    'Photovoltaik Förderung 2026',
    'PV Förderung Deutschland',
    'Photovoltaik Förderung Österreich',
    'EEG Einspeisevergütung 2026',
    'KfW Förderung Photovoltaik',
  ],
  publishedAt: '2026-07-14',
  excerpt:
    'Förderungen ändern den Endpreis Ihrer Solaranlage oft stärker als jede Verhandlung mit dem ' +
    'Handwerksbetrieb. Ein Überblick über Bund, Länder und Kommunen in Deutschland sowie die ' +
    'EAG-Förderung in Österreich - Stand Juli 2026.',
  sections: [
    {
      type: 'paragraph',
      text:
        'Bei der Frage "Was kostet eine Solaranlage?" wird ein Faktor regelmäßig unterschätzt: die ' +
        'Förderung. Zwischen Steuervorteilen, Einspeisevergütung, zinsgünstigen Krediten und ' +
        'kommunalen Zuschüssen kann sich der tatsächliche Endpreis einer Anlage deutlich von der ' +
        'reinen Angebotssumme unterscheiden. Dieser Beitrag fasst den Stand Juli 2026 zusammen - ' +
        'getrennt nach Deutschland und Österreich, da beide Länder komplett unterschiedliche ' +
        'Fördersysteme haben.',
    },
    {
      type: 'heading',
      text: 'Deutschland: Förderung auf drei Ebenen',
    },
    {
      type: 'paragraph',
      text:
        'In Deutschland gibt es Photovoltaik-Förderung auf Bundes-, Landes- und kommunaler Ebene. ' +
        'Die Programme lassen sich meist kombinieren, kommunale Fördertöpfe sind aber oft gedeckelt ' +
        'und schnell ausgeschöpft - je früher der Antrag, desto besser die Chancen.',
    },
    {
      type: 'heading',
      text: 'Bundesebene: Steuervorteile, Einspeisevergütung, KfW-Kredit',
    },
    {
      type: 'list',
      items: [
        '0% Mehrwertsteuer auf Kauf und Installation von Photovoltaikanlagen bis 30 kWp - gilt 2026 unverändert und unbefristet',
        'Einnahmen und Entnahmen aus PV-Anlagen bis 30 kWp sind vollständig einkommensteuerbefreit - keine Gewerbeanmeldung, keine Einnahmen-Überschuss-Rechnung nötig',
        'EEG-Einspeisevergütung: 7,78 ct/kWh (Teileinspeisung bis 10 kWp, Stand Februar 2026), sinkt zum 1. August 2026 auf 7,71 ct/kWh - wer die Anlage 2026 in Betrieb nimmt, sichert sich die jeweils aktuelle Vergütung für 20 Jahre',
        '2026 ist das letzte Jahr der garantierten EEG-Festvergütung für neue Anlagen unter 25 kWp - danach ändert sich das Vergütungssystem',
        'KfW-Kredit 270: zinsgünstige Finanzierung bis zu 100% der Kosten, Zinssätze und Konditionen ändern sich laufend - aktueller Stand direkt bei der KfW prüfen',
      ],
    },
    {
      type: 'heading',
      text: 'Länder und Kommunen: regional sehr unterschiedlich',
    },
    {
      type: 'paragraph',
      text:
        'Auf Landesebene sind 2026 nur noch wenige Bundesländer mit eigenen Förderprogrammen aktiv ' +
        '- mehrere frühere Landesprogramme wurden ohne Nachfolgeprogramm eingestellt. Berlin ist ' +
        'aktuell eines der attraktivsten Bundesländer für private PV-Investitionen (Zuschüsse für ' +
        'Zählerschrankumbau und Batteriespeicher, gedeckeltes Jahresbudget). Da viele Landesprogramme ' +
        'ausgelaufen sind, rücken kommunale Zuschüsse in den Vordergrund - die Förderhöhen reichen ' +
        'von kleinen Balkonkraftwerk-Pauschalen bis zu einigen tausend Euro für Dachanlagen, je nach ' +
        'Gemeinde völlig unterschiedlich. Eine aktuelle, nach Bundesland und Zielgruppe filterbare ' +
        'Übersicht bietet die öffentliche Förderdatenbank des Bundes (foerderdatenbank.de).',
    },
    {
      type: 'paragraph',
      text:
        'Wichtig bei praktisch allen Landes- und Kommunalprogrammen: der Förderantrag muss in der ' +
        'Regel gestellt werden, bevor die Anlage gekauft oder montiert wird - nachträglich ist eine ' +
        'Förderung meist nicht mehr möglich. Das lohnt sich einzuplanen, sobald erste Angebote ' +
        'vorliegen, nicht erst nach der Auftragsvergabe.',
    },
    {
      type: 'heading',
      text: 'Österreich: die EAG-Förderung',
    },
    {
      type: 'paragraph',
      text:
        'Österreich hat ein eigenständiges Fördersystem, das sich deutlich von Deutschland ' +
        'unterscheidet - die folgenden Angaben gelten ausschließlich für Anlagen in Österreich, ' +
        'nicht für Deutschland. Zentral ist die bundesweite EAG-Förderung (Erneuerbaren-Ausbau-' +
        'Gesetz): 150 €/kWp für die ersten 10 kWp Anlagenleistung, 140 €/kWp für die Leistung ' +
        'zwischen 10 und 20 kWp, sowie zusätzlich 150 €/kWh für einen Batteriespeicher. Die ' +
        'Förderung wird in einzelnen "Calls" mit jeweils eigenem Antragsfenster und begrenztem ' +
        'Gesamtbudget vergeben - ist das Budget eines Calls ausgeschöpft, muss der nächste ' +
        'Call abgewartet werden.',
    },
    {
      type: 'paragraph',
      text:
        'Zusätzlich zur Bundesförderung gibt es teils Landes- und Gemeindeförderungen, die sich ' +
        'stark unterscheiden: manche Bundesländer haben keine eigene direkte PV-Förderung, ' +
        'gewähren aber z. B. zusätzliche Punkte bei der Wohnbauförderung; andere Bundesländer ' +
        'haben ein eigenes, jährlich neu budgetiertes Förderprogramm, dessen Budget je nach ' +
        'Nachfrage bereits während des Jahres ausgeschöpft sein kann. Einzelne Gemeinden bieten ' +
        'zusätzlich eigene, meist kleinere Zuschüsse an. Wer in Österreich eine Anlage plant, ' +
        'sollte Bundes-, Landes- und Gemeindeförderung getrennt prüfen, statt nur die EAG-' +
        'Förderung einzuplanen.',
    },
    {
      type: 'heading',
      text: 'Was das für Ihren Angebotsvergleich bedeutet',
    },
    {
      type: 'paragraph',
      text:
        'Förderungen ändern nichts an der Grundlogik des Preisvergleichs: der faire Vergleichs-' +
        'maßstab bleibt der Preis pro kWp vor Förderung, weil Förderungen unabhängig vom gewählten ' +
        'Handwerksbetrieb greifen. Bei Roofora vergleichen Sie zunächst unverbindliche Festpreis-' +
        'Angebote mehrerer Handwerksbetriebe für Ihr Dach - erst danach lohnt sich der Blick auf ' +
        'die für Sie zutreffenden Förderprogramme, um den tatsächlichen Endpreis nach Förderung zu ' +
        'berechnen.',
    },
    {
      type: 'heading',
      text: 'Wichtiger Hinweis',
    },
    {
      type: 'paragraph',
      text:
        'Alle Angaben in diesem Beitrag entsprechen dem Stand Juli 2026 und können sich ändern - ' +
        'insbesondere Fördersätze, Budgets und Antragsfristen werden regelmäßig angepasst oder ' +
        'Programme laufen aus. Dieser Beitrag ersetzt keine individuelle Rechts- oder Steuer-' +
        'beratung. Prüfen Sie die für Ihren Wohnort aktuell gültigen Bedingungen direkt bei der ' +
        'jeweiligen Förderstelle (in Deutschland u. a. foerderdatenbank.de, in Österreich die ' +
        'zuständige Landesstelle bzw. der aktuelle EAG-Call), bevor Sie eine Anlage bestellen.',
    },
  ],
  relatedLinks: [
    { label: 'Was kostet eine Solaranlage?', href: '/solaranlage-kosten' },
    { label: 'PV-Angebote vergleichen', href: '/pv-angebot-vergleichen' },
    { label: 'PV-Kostenrechner: Durchschnittspreis in Sekunden', href: '/pv-kostenrechner' },
    { label: 'Photovoltaik-Förderung: Kurzüberblick & Stand 2026', href: '/photovoltaik-foerderung' },
  ],
}
